import React from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import HeaderBottom from "../components/HomePage/HeaderBottom";

const IndustryPage = ({ page }) => {
  const location = useLocation();
  const canonicalPath =
    location.pathname !== "/" ? location.pathname.replace(/\/+$/, "") : location.pathname;

  return (
    <>
      <Helmet>
        <title>{page.metaTitle}</title>
        <meta name="description" content={page.metaDescription} />
        <link rel="canonical" href={`https://auraweb.click${canonicalPath}`} />
        <meta property="og:title" content={page.metaTitle} />
        <meta property="og:description" content={page.metaDescription} />
        <meta property="og:url" content={`https://auraweb.click${canonicalPath}`} />
      </Helmet>

      <div className="boxed_wrapper ltr">
        <HeaderBottom />

        <section className="pt-5 pb-4">
          <div className="container">
            <div
              className="rounded-4 p-4 p-lg-5 text-white"
              style={{
                background: "linear-gradient(135deg, #111827 0%, #5b1dff 100%)",
              }}
            >
              <div className="row align-items-center g-4">
                <div className="col-lg-8">
                  <h1 className="mb-3" style={{ color: "#fff" }}>
                    {page.h1}
                  </h1>
                  <p className="mb-4 fs-5" style={{ color: "rgba(255,255,255,0.88)" }}>
                    {page.intro}
                  </p>
                  <Link to="/contact-us" className="theme-btn btn-one">
                    Book a Free Demo
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {page.demoEmbed && (
          <section className="py-5" style={{ background: "linear-gradient(135deg, #f8f8ff 0%, #fff8f4 100%)" }}>
            <div className="container">
              <div className="text-center mb-4">
                <span className="badge mb-2 px-3 py-2" style={{ background: "#5b1dff", color: "#fff", borderRadius: "20px", fontSize: "0.85rem" }}>
                  🤖 Live AI Demo
                </span>
                <h2 className="mb-2">{page.demoEmbed.title}</h2>
                <p className="text-muted fs-5">{page.demoEmbed.subtitle}</p>
              </div>
              <div
                className="rounded-4 overflow-hidden shadow"
                style={{ border: "2px solid #e9e0ff", maxWidth: "900px", margin: "0 auto" }}
              >
                <iframe
                  src={page.demoEmbed.url}
                  title={page.demoEmbed.title}
                  width="100%"
                  height="700px"
                  style={{ border: "none", display: "block" }}
                  allow="clipboard-write"
                />
              </div>
              <p className="text-center text-muted mt-3" style={{ fontSize: "0.85rem" }}>
                This is a live demo — try asking about the menu, opening hours, or make a booking!
              </p>
            </div>
          </section>
        )}

        {page.sections.map((section) => (
          <section className="py-5" key={section.h2}>
            <div className="container">
              <div className="mb-4">
                <h2>{section.h2}</h2>
                {section.lead ? <p className="fs-5 text-dark mt-3 mb-0">{section.lead}</p> : null}
              </div>

              {section.blocks ? (
                <div className="row g-4">
                  {section.blocks.map((block) => (
                    <div className="col-lg-6" key={block.h3}>
                      <div className="h-100 p-4 rounded-4 border shadow-sm bg-white">
                        <h3 className="mb-3">{block.h3}</h3>
                        <p className="mb-0">{block.body}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}

              {section.bullets ? (
                <div className="row">
                  <div className="col-lg-10">
                    <ul className="list-unstyled mb-0">
                      {section.bullets.map((bullet) => (
                        <li className="d-flex align-items-start mb-3" key={bullet}>
                          <span className="me-3" style={{ color: "#5b1dff", fontWeight: 700 }}>
                            ✓
                          </span>
                          <span>{bullet}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : null}

              {section.ordered ? (
                <ol className="ps-3 mb-0">
                  {section.ordered.map((item) => (
                    <li className="mb-3" key={item}>
                      {item}
                    </li>
                  ))}
                </ol>
              ) : null}

              {section.faqs ? (
                <div className="row g-4">
                  {section.faqs.map((faq) => (
                    <div className="col-lg-6" key={faq.q}>
                      <div className="h-100 p-4 rounded-4 border bg-light">
                        <h3 className="h5 mb-3">{faq.q}</h3>
                        <p className="mb-0">{faq.a}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}

              {section.cta ? (
                <div className="mt-4">
                  <Link to={section.ctaTo} className="theme-btn btn-one">
                    {section.cta}
                  </Link>
                </div>
              ) : null}
            </div>
          </section>
        ))}

        <section className="pb-5">
          <div className="container">
            <div className="rounded-4 border shadow-sm p-4 p-lg-5 bg-white text-center">
              <h2 className="mb-3">{page.finalCtaTitle}</h2>
              <p className="mb-4 fs-5">{page.finalCtaBody}</p>
              <Link to="/contact-us" className="theme-btn btn-one">
                {page.finalCtaLabel}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default IndustryPage;
